import { Column } from '../container/Container';
import { InputController } from '../inputs/InputController';
import ResizeTextArea from '../form-inputs/ResizeTextArea';
import TextInput from '../inputs/TextInput';
import { TextBodyExtraExtraSmall } from '../text/Texts';

type Props = {
	control?: any;
	formName?: string;
};

const ProgramDetailFields = (props: Props) => {
	const { control, formName } = props;
	return (
		<Column className="gap-4 w-[668px]">
			<Column className="w-full">
				<InputController id="name" control={control}>
					<TextInput label="Program name" variant="outlined" />
				</InputController>
				<TextBodyExtraExtraSmall
					className="px-4 pt-1 text-neutralVariant20"
					text="Participants will see your program name in the Xpress App"
				/>
			</Column>
			<Column className="w-full bg-white">

				<ResizeTextArea
					id="description"
					control={control}
					formName={formName!}
					label="Description"
				/>

				<TextBodyExtraExtraSmall
					className="px-4 pt-1 text-neutralVariant20"
					text="People in the Xpress app will see this description"
				/>
			</Column>
		</Column>
	);
};

export default ProgramDetailFields;
